/* eslint-disable */
/**
 * Translations for App Interface
 */

const appTranslations = {

	"pt_BR": {

		//Menu 
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescrição",
		"Over and Under-Dosage": "Efeitos da super e subdosagem",
		"Thyroid Journal": "Diário da Tireoide",
		"Pack Calculator": "Calculadora de Embalagens",
		"Technical Data": "Dados técnicos",
		"Discover": "Descubra",
		//menu descriptions
		"General information about different thyroid conditions.": "Informação geral sobre as diversas patologias da tireoide.",
		"Calculate initial and maintenance dosages for your patients.": "Cálculo da dose inicial e de manutenção recomendadas para os seus doentes.",
		"Overview of the symptoms.": "Visão geral dos sintomas.",
		"A document to track your patients' thyroid health.": "Um documento para acompanhamento da saúde da tireoide dos seus doentes.",
		"Find the pack better suited for your dosage.": "Descubra a embalagem mais adequada para a sua dosagem.",
		"Refer to the SPC.": "Ver a bula do medicamento.",

		//i menu
		"References": "Referências",

		// Prescription
		"Prescription": "Prescrição",
		"Calculate recommended initial and maintenance dosages": "Calcule a dose inicial e de manutenção recomendadas",
		"Calculate pack sizes": "Calcular quantidade de embalagens",
		"Levothyroxin Dosage Calculator": "Calculadora de dose de levotiroxina",
		"Intro text (need to be produced)": "Calcule a dose inicial e de manutenção recomendadas para o seu paciente.",
		"Hypothyroidism": "Hipotireoidismo",
		"Congenital or Replacement Therapy": "Congênito ou terapia de reposição",
		"Demographic": "Demografia",
		"Age group": "Grupo etário",

		"year": "ano",
		"years": "anos",
		"Gender": "Gênero",
		"Male": "Homem",
		"Female": "Mulher",
		"Condition": "Condição",
		"Which situation is best suited for your patient?": "Qual a condição que melhor se adequa ao seu paciente?",
		"Without associated diseases": "Sem doenças associadas",
		"Pregnancy and breastfeeding": "Gravidez e lactação",
		"The elderly or people with heart disease": "Idosos ou pessoas com doenças cardiovasculares ",
		"What are the TSH levels, weight and height of your patient?": "Quais são os níveis de T4, TSH, altura e peso do seu paciente?",
		"TSH Levels": "Nível TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Insira os níveis de TSH, peso e altura do seu paciente",
		"Review your choices": "Reveja suas escolhas",
		"The recommended doses of levothyroxine are:": "As doses recomendadas de levotiroxina são:",
		"Initial dose": "Dose inicial",
		"Maintenance dose": "Dose de manutenção",
		"BMI": "IMC",
		"Body Surface Area": "Área de Superfície Corporal",
		"Click button to continue": "Clique no botão para continuar",
		"Select an option to continue": "Selecione uma opção para continuar",
		"Review Choices": "Rever as escolhas",
		"Close": "Fechar",
		"Intro": "Introdução",
		"Demographic": "Demografia",
		"Condition": "Condições",
		"Analysis": "Análise",
		"Review": "Visão Geral",
		"Calculate Dosages": "Calcular Dosagens",
		"Treatment control": "Tratamento de controlo",

		"Confirm": "Confirmar",
		"Back to previous question": "Voltar à pergunta anterior",
		"Result": "Resultado",
		"Results": "Resultados",

		//pack calculator
		"What is the intended prescription dosage?": "Qual a dosagem prescrita?",
		"mcg/day": "µg/dia",
		"Insert the patient's daily dosage": "Insira a dose diária do paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "A embalagem recomendada para uma dose diária de %num% mcg durante %days% dias é:",
		"Pack": "Embalagem",
		"Packs": "Embalagens",
		"Dosage": "Dose",
		"Day": "Dia",
		"day": "dia",
		"day": "dia",
		"Days": "Dias",
		"Maximum 299 days": "Máximo 299 dias",
		"pc-boxes": "%num% (embalagem|embalagens) de %quant% comprimidos",

		//Specific sentences for prescription
		"pc-intro-txt": "<p>Terapia de reposição ou suplementação hormonal em pacientes com hipotireoidismo de qualquer etiologia (exceto no hipotireoidismo transitório, durante a fase de recuperação de tireoidite subaguda).</p> <p>Supressão do TSH hipofisário no tratamento ou prevenção dos vários tipos de bócios eutireoidianos, inclusive nódulos tireoidianos, tireoidite linfocítica subaguda ou crônica (tireoidite de Hashimoto) e carcinomas foliculares e papilares, tireotropino-dependentes da tireoide.</p> <p>Diagnóstico nos testes de supressão, auxiliando no diagnóstico da suspeita de hipertireoidismo leve ou de glândula tireoide autônoma.</p>",

		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "A levotiroxina é um fármaco de margem terapêutica estreita. Sendo assim, o médico deve assinalar na receita a exceção legal correspondente a este grupo de fármacos para impedir a troca de marcas na farmácia:",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "“Exceção a) do n.°3 do art. 6o. - Margem ou índice terapêutico estreito.”",
		"A mere change of brand can alter patient hormone levels by itself.": "A troca de marcas por si só pode alterar os níveis hormonais dos pacientes.",
	},

	"es_CL": {
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescripción",
		"Over and Under-Dosage": "Sobredosificación y Subdosificación",
		"Thyroid Journal": "Diario de Tiroides",
		"Pack Calculator": "Calculadora de cajas",
		"Technical Data": "Datos técnicos",
		"Discover": "Descubrir",
		"General information about different thyroid conditions.": "Información general sobre diferentes afecciones de la tiroides.",
		"Calculate initial and maintenance dosages for your patients.": "Calcular las doses iniciales y de mantenimiento para sus pacientes.",
		"Calculate pack sizes": "Calcular cantidad de cajas",
		"Overview of the symptoms.": "Resumen de los síntomas.",
		"A document to track your patients' thyroid health.": "Un documento para realizar un seguimiento de la salud de la tiroides de sus pacientes.",
		"Find the pack better suited for your dosage.": "Encontre la caja más adecuado para su dosificación.",
		"Refer to the SPC.": "Consulte el SPC.",
		"Calculate recommended initial and maintenance dosages": "Cálculo sugerido para dosis inicial y de mantenimiento",
		"Levothyroxin Dosage Calculator": "Calculadora de dosis de Eutirox®",
		"Hypothyroidism": "Hipofunción tiroidea (hipotiroidismo)",
		"Congenital or Replacement Therapy": "indicado para Terapia de reemplazo o sustitución de la función tiroidea ausente o deprimida y supresión de la secreción de tirotrofina.",
		"Demographic": "Demográfico",
		"Age group": "Grupo de edad",
		"year": "año",
		"years": "años",
		"Gender": "Género",
		"Male": "Hombre",
		"Female": "Mujer",
		"Condition": "Condición",
		"Which situation is best suited for your patient?": "¿Qué situación es la más adecuada para su paciente?",
		"Without associated diseases": "Sin enfermedades asociadas",
		"Pregnancy and breastfeeding": "Embarazo y lactancia",
		"The elderly or people with heart disease": "Anciano o personas com enfermidades cardíacas",
		"What are the TSH levels, weight and height of your patient?": "¿Cuáles son los niveles de TSH, el peso e la altura de su paciente?",
		"TSH Levels": "Niveles de TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Inserte los niveles de TSH, el peso y la altura del paciente",
		"Review your choices": "Revise sus elecciones",
		"The recommended doses of levothyroxine are:": "Las dosis recomendadas de Eutirox® son:",
		"Initial dose": "Dosis recomendada de acuerdo a folleto del producto",
		"Maintenance dose": "Dosis de mantenimiento",
		"Dose Calculation (TSH)": "Dosis de levotiroxina según TSH",
		"BMI": "IMC",
		"Body Surface Area": "Área superficial del cuerpo",
		"Click button to continue": "Haga clic en el botón para continuar",
		"Select an option to continue": "Seleccione una opción para continuar",
		"Review Choices": "Revisar opciones",
		"Close": "Cerrar",
		"Intro": "Introducción",
		"Analysis": "Análisis",
		"Review": "Revisión",
		"Back to previous question": "Volver a la pregunta anterior",
		"Calculate Dosages": "Calcular las dosis",
		"Confirm": "Confirmar",
		"Year": "Año",
		"Years": "Años",
		"Result": "Resultado",
		"Results": "Resultados",
		"What is the intended prescription dosage?": "¿Cuál es la dosis de prescripción prevista?",
		"mcg/day": "mcg/día",
		"Insert the patient's daily dosage": "Insertar la dosis diaria del paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "La caja recomendada para una dosis diaria de %num% durante %days% días es:",
		"Pack": "Caja",
		"Packs": "Cajas",
		"pc-boxes": "%num% (caja|cajas) de %quant% comprimidos",
		"Dosage": "Dosis",
		"Day": "Día",
		"day": "día",
		"Days": "Días",
		"References": "Referencias",
		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "La levotiroxina es un medicamento de margen terapéutico estrecho. Por ello, el clínico prescriptor debe marcar en la receta la excepción legal correspondiente a este grupo de medicamentos para evitar el cambio de marcas en la farmacia:",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "«Excepción a) del n.º 3 del art. 6 - Margen o índice terapéutico estrecho».",
		"A mere change of brand can alter patient hormone levels by itself.": "El cambio de marcas por sí mismo puede alterar los niveles hormonales de los pacientes.",
		"Maximum 299 days": "Máximo 299 días",
		"pc-intro-txt": "<p>Esta herramienta calcula la dosis para Hipofunción tiroidea (hipotiroidismo) indicado para Terapia de reemplazo o sustitución de la función tiroidea ausente o deprimida y supresión de la secreción de tirotrofina.</p>"
	},

	"pt_PT": {
	    "Diagnosis": "Diagnóstico",
	    "Prescription": "Prescrição",
	    "Over and Under-Dosage": "Sobre e Subdosagem",
	    "Thyroid Journal": "Diário da Tiroide",
	    "Pack Calculator": "Calculadora de embalagem de Eutirox<sup>®</sup>",
	    "Technical Data": "Informação Técnica",
	    "Discover": "Descubra",
	    "General information about different thyroid conditions.": "Informações gerais sobre as diferentes condições da tiroide.",
	    "Calculate initial and maintenance dosages for your patients.": "Calcule as doses iniciais e de manutenção dos seus doentes.",
		"Calculate pack sizes": "Calcular quantidade de embalagens",
	    "Overview of the symptoms.": "Resumo dos sintomas.",
	    "A document to track your patients' thyroid health.": "Um documento para acompanhar a saúde da tiroide dos seus doentes.",
	    "Find the pack better suited for your dosage.": "Encontre a embalagem adequada para a sua dose.",
	    "Refer to the SPC.": "Consulte o RCM.",
	    "Calculate recommended initial and maintenance dosages": "Calcule a dose inicial e de manutenção",
	    "Levothyroxin Dosage Calculator": "Calculadora de dose de levotiroxina",
	    "Intro text (need to be produced)": "Texto introdutório (em desenvolvimento)",
	    "Hypothyroidism": "Hipotiroidismo",
		"Congenital or Replacement Therapy": "Congénito ou terapia de substituição",
	    "Demographic": "Demográficos",
	    "Age group": "Idade",
	    "year": "Ano",
	    "years": "anos",
	    "Gender": "Género",
	    "Male": "Masculino",
	    "Female": "Feminino",
	    "Condition": "Doença",
	    "Which situation is best suited for your patient?": "Qual é a situação mais adequada para o seu doente?",
	    "Without associated diseases": "Sem doenças associadas",
	    "Pregnancy and breastfeeding": "Gravidez e amamentação",
	    "The elderly or people with heart disease": "Idosos ou pessoas com doença cardíaca",
	    "What are the TSH levels, weight and height of your patient?": "Quais são os valores de peso e altura do seu doente?",
	    "TSH Levels": "Valor de TSH",
	    "Weight": "Peso",
	    "Height": "Altura",
	    "Insert the patient's TSH Levels, weight and height": "Insira os valores de peso e altura do seu doente",
	    "Review your choices": "Reveja os seus valores",
	    "The recommended doses of levothyroxine are:": "As doses recomendadas de levotiroxina são:",
	    "Initial dose": "Dose inicial",
	    "Maintenance dose": "Dose de manutenção",
	    "BMI": "IMC",
	    "Body Surface Area": "Superfície Corporal",
	    "Click button to continue": "Clique para continuar",
	    "Select an option to continue": "Selecione uma opção para continuar",
	    "Review Choices": "Reveja as suas escolhas",
	    "Close": "Fechar",
	    "Intro": "Introdução",
	    "Analysis": "Análise",
	    "Review": "Revisão",
	    "Back to previous question": "Voltar à questão anterior",
	    "Calculate Dosages": "Calcular dose",
	    "Confirm": "Confirmar",
	    "Year": "Ano",
	    "Years": "Anos",
	    "Result": "Resultado",
	    "Results": "Resultados",
	    "What is the intended prescription dosage?": "Qual é a dose de prescrição?",
	    "mcg/day": "mcg/dia",
	    "Insert the patient's daily dosage": "Insira a dose diária do seu doente",
	    "The recommended pack for a %num% mcg daily dosage for %days% days is:": "O número de embalagens necessárias para %days% dias de tratamento é:",
	    "Pack": "Embalagem",
	    "Packs": "Embalagens",
		"pc-boxes": "%num% (embalagem|embalagens) de %quant% comprimidos",
	    "Dosage": "Dose",
	    "Day": "Dia",
	    "day": "dia",
	    "Days": "Dias",
	    "References": "Referências",
	    "Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "<b>A levotiroxina é um fármaco de Margem Terapêutica Estreita</b> &ndash; Deliberação INFARMED Nº 70/CD/2012. Disponível em: https://www.infarmed.pt/documents/15786/1219405/070_CD_2012.pdf. Consultado em 22/02/2024",
	    "“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "“Exceção a) do n.°3 do art. 6o. - Margem ou índice terapêutico estreito.”",
	    "A mere change of brand can alter patient hormone levels by itself.": "Um desajuste na dose de levotiroxina pode ter consequências clínicas porque os limites entre a dose terapêutica e as doses tóxica e subclínica são curtos. Se a TSH estiver dentro dos limites desejados com uma determinada marca de levotiroxina, não deve substituída. Caso haja substituição da marca de levotiroxina, nova avaliação da função tiroideia deve ser efetuada 4 a 8 semanas após a alteração. &ndash; Grupo de Estudo da Tiroide. Disponível em: https://www.spedm.pt/grupode-estudo-da-tiroide/ogrupo-de-estudos-da-tiroidealertou-o-infarmed-para-orisco-da-troca-delevotiroxina-para-ogenerico/ .",
	    "Maximum 299 days": "Máximo 299 dias",
		"pc-intro-txt": "<p>Esta ferramenta calcula a dose de levotiroxina, indicada na terapêutica de substituição no Hipotiroidismo.</p>",
		"pc-disclaimer": "O resultado apresentado é apenas uma recomendação ficando ao critério do médico a decisão da prescrição."
	},

	// Central
	"es_CT": {
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescripción",
		"Over and Under-Dosage": "Sobredosificación y Subdosificación",
		"Thyroid Journal": "Diario de Tiroides",
		"Pack Calculator": "Calculadora de cajas",
		"Technical Data": "Datos técnicos",
		"Discover": "Descubrir",
		"General information about different thyroid conditions.": "Información general sobre diferentes afecciones de la tiroides.",
		"Calculate initial and maintenance dosages for your patients.": "Calcular las doses iniciales y de mantenimiento para sus pacientes.",
		"Calculate pack sizes": "Calcular quantidad de cajas",
		"Overview of the symptoms.": "Resumen de los síntomas.",
		"A document to track your patients' thyroid health.": "Un documento para realizar un seguimiento de la salud de la tiroides de sus pacientes.",
		"Find the pack better suited for your dosage.": "Encontre la caja más adecuado para su dosificación.",
		"Refer to the SPC.": "Consulte el SPC.",
		"Calculate recommended initial and maintenance dosages": "Cálculo para dosis inicial sugerida y dosis máxima estimada.",
		"Levothyroxin Dosage Calculator": "Calculadora de dosis de Eutirox<sup>®</sup>",
		// differs
		"Hypothyroidism": "Terapia de sustitución en hipotiroidismo",
		// differs
		"Congenital or Replacement Therapy": "(para reemplazar las hormonas tiroideas naturales, cuando su glándula tiroidea no produce suficiente)",
		"Demographic": "Demográfico",
		"Age group": "Grupo de edad",
		"year": "año",
		"years": "años",
		"Gender": "Género",
		"Male": "Hombre",
		"Female": "Mujer",
		"Condition": "Condición",
		"Which situation is best suited for your patient?": "¿Qué situación es la más adecuada para su paciente?",
		"Without associated diseases": "Sin enfermedades asociadas",
		"Pregnancy and breastfeeding": "Embarazo y lactancia",
		"The elderly or people with heart disease": "Ancianos o personas con enfermedades cardíacas",
		"What are the TSH levels, weight and height of your patient?": "¿Cuál es el peso y la altura de su paciente?",
		"TSH Levels": "Niveles de TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Registre el peso y la altura del paciente",
		"Review your choices": "Revise sus elecciones",
		"The recommended doses of levothyroxine are:": "La dosis inicial sugerida de Eutirox<sup>®</sup> es:”",
		"Initial dose": "Dosis inicial sugerida",
		"Maintenance dose": "Dosis máxima estimada",
		"Dose Calculation (TSH)": "Cálculo de dosis (TSH)",
		"BMI": "IMC",
		"Body Surface Area": "Área superficial del cuerpo",
		"Click button to continue": "Haga clic en el botón para continuar",
		"Select an option to continue": "Seleccione una opción para continuar",
		"Review Choices": "Revisar opciones",
		"Close": "Cerrar",
		"Intro": "Introducción",
		"Analysis": "Análisis",
		"Review": "Revisión",
		"Back to previous question": "Volver a la pregunta anterior",
		"Calculate Dosages": "Calcular las dosis",
		"Confirm": "Confirmar",
		"Year": "Año",
		"Years": "Años",
		"Result": "Resultado",
		"Results": "Resultados",
		"What is the intended prescription dosage?": "¿Cuál es la dosis de prescripción prevista?",
		"mcg/day": "mcg/día",
		"Insert the patient's daily dosage": "Insertar la dosis diaria del paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "La caja recomendada para una dosis diaria de %num%mcg durante %days% días es:",
		"Pack": "Paquete",
		"Packs": "Paquetes",
		"pc-boxes": "%num% (caja|cajas) de %quant% comprimidos",
		"Dosage": "Dosis",
		"Day": "Día",
		"day": "día",
		"Days": "Días",
		"References": "Referencias",
		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "La levotiroxina es un medicamento de margen terapéutico estrecho. Por ello, el clínico prescriptor debe marcar en la receta la excepción legal correspondiente a este grupo de medicamentos para evitar el cambio de marcas en la farmacia:",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "«Excepción a) del n.º 3 del art. 6 - Margen o índice terapéutico estrecho».",
		"A mere change of brand can alter patient hormone levels by itself.": "El cambio de marcas por sí mismo puede alterar los niveles hormonales de los pacientes.",
		"Maximum 299 days": "Máximo 299 días",
		// differs
		"pc-intro-txt": "<p>Esta herramienta calcula la dosis para Terapia de sustitución en hipotiroidismo (para reemplazar las hormonas tiroideas naturales, cuando su glándula tiroidea no produce suficiente), adicionalmente para:</p> <ul><li>Tratamiento del bocio eutiroideo benigno en pacientes con función tiroidea normal,</li> <li>Profilaxis de recidiva después de cirugía para bocio eutiroideo, dependiendo del estado hormonal después de la operación,</li> <li>Terapia de supresión en cáncer de tiroides (para suprimir el crecimiento del tumor en pacientes con cáncer de tiroides).</li></ul>"
	},

	// Central
	"es_GT": {
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescripción",
		"Over and Under-Dosage": "Sobredosificación y Subdosificación",
		"Thyroid Journal": "Diario de Tiroides",
		"Pack Calculator": "Calculadora de cajas",
		"Technical Data": "Datos técnicos",
		"Discover": "Descubrir",
		"General information about different thyroid conditions.": "Información general sobre diferentes afecciones de la tiroides.",
		"Calculate initial and maintenance dosages for your patients.": "Calcular las doses iniciales y de mantenimiento para sus pacientes.",
		"Calculate pack sizes": "Calcular quantidad de cajas",
		"Overview of the symptoms.": "Resumen de los síntomas.",
		"A document to track your patients' thyroid health.": "Un documento para realizar un seguimiento de la salud de la tiroides de sus pacientes.",
		"Find the pack better suited for your dosage.": "Encontre la caja más adecuado para su dosificación.",
		"Refer to the SPC.": "Consulte el SPC.",
		"Calculate recommended initial and maintenance dosages": "Cálculo para dosis inicial sugerida y dosis máxima estimada.",
		"Levothyroxin Dosage Calculator": "Calculadora de dosis de Eutirox<sup>®</sup>",
		// differs
		"Hypothyroidism": "Terapia de sustitución en hipotiroidismo",
		// differs
		"Congenital or Replacement Therapy": "(para reemplazar las hormonas tiroideas naturales, cuando su glándula tiroidea no produce suficiente)",
		"Demographic": "Demográfico",
		"Age group": "Grupo de edad",
		"year": "año",
		"years": "años",
		"Gender": "Género",
		"Male": "Hombre",
		"Female": "Mujer",
		"Condition": "Condición",
		"Which situation is best suited for your patient?": "¿Qué situación es la más adecuada para su paciente?",
		"Without associated diseases": "Sin enfermedades asociadas",
		"Pregnancy and breastfeeding": "Embarazo y lactancia",
		"The elderly or people with heart disease": "Ancianos o personas con enfermedades cardíacas",
		"What are the TSH levels, weight and height of your patient?": "¿Cuál es el peso y la altura de su paciente?",
		"TSH Levels": "Niveles de TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Registre el peso y la altura del paciente",
		"Review your choices": "Revise sus elecciones",
		"The recommended doses of levothyroxine are:": "La dosis inicial sugerida de Eutirox<sup>®</sup> es:”",
		"Initial dose": "Dosis inicial sugerida",
		"Maintenance dose": "Dosis máxima estimada",
		"Dose Calculation (TSH)": "Cálculo de dosis (TSH)",
		"BMI": "IMC",
		"Body Surface Area": "Área superficial del cuerpo",
		"Click button to continue": "Haga clic en el botón para continuar",
		"Select an option to continue": "Seleccione una opción para continuar",
		"Review Choices": "Revisar opciones",
		"Close": "Cerrar",
		"Intro": "Introducción",
		"Analysis": "Análisis",
		"Review": "Revisión",
		"Back to previous question": "Volver a la pregunta anterior",
		"Calculate Dosages": "Calcular las dosis",
		"Confirm": "Confirmar",
		"Year": "Año",
		"Years": "Años",
		"Result": "Resultado",
		"Results": "Resultados",
		"What is the intended prescription dosage?": "¿Cuál es la dosis de prescripción prevista?",
		"mcg/day": "mcg/día",
		"Insert the patient's daily dosage": "Insertar la dosis diaria del paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "La caja recomendada para una dosis diaria de %num%mcg durante %days% días es:",
		"Pack": "Paquete",
		"Packs": "Paquetes",
		"pc-boxes": "%num% (caja|cajas) de %quant% comprimidos",
		"Dosage": "Dosis",
		"Day": "Día",
		"day": "día",
		"Days": "Días",
		"References": "Referencias",
		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "La levotiroxina es un medicamento de margen terapéutico estrecho. Por ello, el clínico prescriptor debe marcar en la receta la excepción legal correspondiente a este grupo de medicamentos para evitar el cambio de marcas en la farmacia:",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "«Excepción a) del n.º 3 del art. 6 - Margen o índice terapéutico estrecho».",
		"A mere change of brand can alter patient hormone levels by itself.": "El cambio de marcas por sí mismo puede alterar los niveles hormonales de los pacientes.",
		"Maximum 299 days": "Máximo 299 días",
		// differs
		"pc-intro-txt": "<p>Esta herramienta calcula la dosis para Terapia de sustitución en hipotiroidismo (para reemplazar las hormonas tiroideas naturales, cuando su glándula tiroidea no produce suficiente), adicionalmente para:</p> <ul><li>Tratamiento del bocio eutiroideo benigno en pacientes con función tiroidea normal,</li> <li>Profilaxis de recidiva después de cirugía para bocio eutiroideo, dependiendo del estado hormonal después de la operación,</li> <li>Terapia de supresión en cáncer de tiroides (para suprimir el crecimiento del tumor en pacientes con cáncer de tiroides).</li></ul>"
	},

	// Central (since default is in English, 
	// only string differing from the original are included)
	"en_CT": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		"Levothyroxin Dosage Calculator": "Eutirox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goitre in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goitre, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Eutirox<sup>®</sup> is:"
	},

	// Central (since default is in English, 
	// only string differing from the original are included)
	"en_GT": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		"Levothyroxin Dosage Calculator": "Eutirox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goitre in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goitre, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Eutirox<sup>®</sup> is:"
	},

	"es_CO": {
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescripción",
		"Over and Under-Dosage": "Sobredosificación y Subdosificación",
		"Thyroid Journal": "Diario de Tiroides",
		"Pack Calculator": "Calculadora de cajas",
		"Technical Data": "Datos técnicos",
		"Discover": "Descubrir",
		"General information about different thyroid conditions.": "Información general sobre diferentes afecciones de la tiroides.",
		"Calculate initial and maintenance dosages for your patients.": "Calcular las doses iniciales y de mantenimiento para sus pacientes.",
		"Overview of the symptoms.": "Resumen de los síntomas.",
		"A document to track your patients' thyroid health.": "Un documento para realizar un seguimiento de la salud de la tiroides de sus pacientes.",
		"Find the pack better suited for your dosage.": "Encontre el paquete más adecuado para su dosificación.",
		"Refer to the SPC.": "Consulte el SPC.",
		"Calculate recommended initial and maintenance dosages": "Dosis inicial y dosis máxima sugerida",
		"Calculate pack sizes": "Calcular cantidad de cajas",
		"Levothyroxin Dosage Calculator": "Calculadora de dosis de levotiroxina",
		// change
		"Hypothyroidism": "Hipotiroidismo",
		// cange
		"Congenital or Replacement Therapy": "indicado para la Suplencia de la hormona Tiroidea y Supresión de concentraciones plasmáticas de TSH para remover el factor trófico en el tratamiento de cáncer de tiroides.",
		"Demographic": "Demográfico",
		"Age group": "Grupo de edad",
		"year": "año",
		"years": "años",
		"Gender": "Género",
		"Male": "Hombre",
		"Female": "Mujer",
		"Condition": "Condición",
		"Which situation is best suited for your patient?": "¿Qué situación es la más adecuada para su paciente?",
		"Without associated diseases": "Sin enfermedades asociadas",
		"Pregnancy and breastfeeding": "Embarazo y lactancia",
		"The elderly or people with heart disease": "Ancianos o personas con enfermedades cardíacas",
		"What are the TSH levels, weight and height of your patient?": "¿Cuáles son los niveles de TSH, el peso e la altura de su paciente?",
		"TSH Levels": "Niveles de TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Inserte los niveles de TSH, el peso y la altura del paciente",
		"Review your choices": "Revise sus elecciones",
		"The recommended doses of levothyroxine are:": "Las dosis recomendadas de levotiroxina son:",
		// change
		"Initial dose": "Dosis inicial sugerida",
		// change
		"Maintenance dose": "Dosis máxima sugerida",
		"Dose Calculation (TSH)": "Cálculo de dosis (TSH)",
		"BMI": "IMC",
		"Body Surface Area": "Área superficial del cuerpo",
		"Click button to continue": "Haga clic en el botón para continuar",
		"Select an option to continue": "Seleccione una opción para continuar",
		"Review Choices": "Revisar opciones",
		"Close": "Cerrar",
		"Intro": "Introducción",
		"Analysis": "Análisis",
		"Review": "Revisión",
		"Back to previous question": "Volver a la pregunta anterior",
		"Calculate Dosages": "Calcular las dosis",
		"Confirm": "Confirmar",
		"Year": "Año",
		"Years": "Años",
		"Result": "Resultado",
		"Results": "Resultados",
		"What is the intended prescription dosage?": "¿Cuál es la dosis de prescripción prevista?",
		"mcg/day": "mcg/día",
		"Insert the patient's daily dosage": "Insertar la dosis diaria del paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "La caja recomendada para una dosis diaria de %num% durante %days% días es:",
		"Pack": "Caja",
		"Packs": "Cajas",
		"pc-boxes": "%num% (caja|cajas) de %quant% comprimidos",
		"Dosage": "Dosis",
		"Day": "Día",
		"day": "día",
		"Days": "Días",
		"References": "Referencias",
		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "La levotiroxina es un medicamento de margen terapéutico estrecho. Por ello, el clínico prescriptor debe marcar en la receta la excepción legal correspondiente a este grupo de medicamentos para evitar el cambio de marcas en la farmacia:",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "«Excepción a) del n.º 3 del art. 6 - Margen o índice terapéutico estrecho».",
		"A mere change of brand can alter patient hormone levels by itself.": "El cambio de marcas por sí mismo puede alterar los niveles hormonales de los pacientes.",
		"Maximum 299 days": "Máximo 299 días",
		"pc-intro-txt": "<p>Esta herramienta calcula la dosis para Hipotiroidismo indicado para la Suplencia de la hormona Tiroidea. Eutirox<sup>®</sup> está también indicado en la supresión de concentraciones plasmáticas de TSH para remover el factor trófico en el tratamiento de cáncer de tiroides.</p>"
	},

	"es_EC": {
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescripción",
		"Over and Under-Dosage": "Sobredosificación y Subdosificación",
		"Thyroid Journal": "Diario de Tiroides",
		"Pack Calculator": "Calculadora de cajas",
		"Technical Data": "Datos técnicos",
		"Discover": "Descubrir",
		"General information about different thyroid conditions.": "Información general sobre diferentes afecciones de la tiroides.",
		"Calculate initial and maintenance dosages for your patients.": "Calcular las doses iniciales y de mantenimiento para sus pacientes.",
		"Calculate pack sizes": "Calcular cantidad de cajas",
		"Overview of the symptoms.": "Resumen de los síntomas.",
		"A document to track your patients' thyroid health.": "Un documento para realizar un seguimiento de la salud de la tiroides de sus pacientes.",
		"Find the pack better suited for your dosage.": "Encontre el paquete más adecuado para su dosificación.",
		"Refer to the SPC.": "Consulte el SPC.",
		"Calculate recommended initial and maintenance dosages": "Dosis inicial y dosis máxima sugerida",
		"Levothyroxin Dosage Calculator": "Calculadora de dosis de levotiroxina",
		// change
		"Hypothyroidism": "Terapia de reemplazo en hipotiroidismo",
		// cange
		"Congenital or Replacement Therapy": "Tratamiento de bocio eutiroideo benigno, Profilaxis de recaída después de cirugía por bocio eutiroideo, dependiendo del estado hormonal postoperatorio, Terapia de supresión en cáncer de tiroides",
		"Demographic": "Demográfico",
		"Age group": "Grupo de edad",
		"year": "año",
		"years": "años",
		"Gender": "Género",
		"Male": "Hombre",
		"Female": "Mujer",
		"Condition": "Condición",
		"Which situation is best suited for your patient?": "¿Qué situación es la más adecuada para su paciente?",
		"Without associated diseases": "Sin enfermedades asociadas",
		"Pregnancy and breastfeeding": "Embarazo y lactancia",
		"The elderly or people with heart disease": "Ancianos o personas con enfermedades cardíacas",
		"What are the TSH levels, weight and height of your patient?": "¿Cuáles son los niveles de TSH, el peso e la altura de su paciente?",
		"TSH Levels": "Niveles de TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Inserte los niveles de TSH, el peso y la altura del paciente",
		"Review your choices": "Revise sus elecciones",
		"The recommended doses of levothyroxine are:": "Las dosis recomendadas de levotiroxina son:",
		// change
		"Initial dose": "Dosis inicial sugerida",
		// change
		"Maintenance dose": "Dosis máxima sugerida",
		"Dose Calculation (TSH)": "Cálculo de dosis (TSH)",
		"BMI": "IMC",
		"Body Surface Area": "Área superficial del cuerpo",
		"Click button to continue": "Haga clic en el botón para continuar",
		"Select an option to continue": "Seleccione una opción para continuar",
		"Review Choices": "Revisar opciones",
		"Close": "Cerrar",
		"Intro": "Introducción",
		"Analysis": "Análisis",
		"Review": "Revisión",
		"Back to previous question": "Volver a la pregunta anterior",
		"Calculate Dosages": "Calcular las dosis",
		"Confirm": "Confirmar",
		"Year": "Año",
		"Years": "Años",
		"Result": "Resultado",
		"Results": "Resultados",
		"What is the intended prescription dosage?": "¿Cuál es la dosis de prescripción prevista?",
		"mcg/day": "mcg/día",
		"Insert the patient's daily dosage": "Insertar la dosis diaria del paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "La caja recomendada para una dosis diaria de %num% durante %days% días es:",
		"Pack": "Caja",
		"Packs": "Cajas",
		"pc-boxes": "%num% (caja|cajas) de %quant% comprimidos",
		"Dosage": "Dosis",
		"Day": "Día",
		"day": "día",
		"Days": "Días",
		"References": "Referencias",
		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "La levotiroxina es un medicamento de margen terapéutico estrecho. Por ello, el clínico prescriptor debe marcar en la receta la excepción legal correspondiente a este grupo de medicamentos para evitar el cambio de marcas en la farmacia:",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "«Excepción a) del n.º 3 del art. 6 - Margen o índice terapéutico estrecho».",
		"A mere change of brand can alter patient hormone levels by itself.": "El cambio de marcas por sí mismo puede alterar los niveles hormonales de los pacientes.",
		"Maximum 299 days": "Máximo 299 días",
		// change
		"pc-intro-txt": "<p>Esta herramienta calcula la dosis para Terapia de reemplazo en hipotiroidismo.</p> <p>Eutirox<sup>®</sup> está también indicado en:</p> <ul> <li>Tratamiento de bocio eutiroideo benigno.</li> <li>Profilaxis de recaída después de cirugía por bocio eutiroideo, dependiendo del estado hormonal postoperatorio.</li> <li>Terapia de supresión en cancer de tiroides.</li> </ul>"
	},

	"es_PE": {
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescripción",
		"Over and Under-Dosage": "Sobredosificación y Subdosificación",
		"Thyroid Journal": "Diario de Tiroides",
		"Pack Calculator": "Calculadora de cajas",
		"Technical Data": "Datos técnicos",
		"Discover": "Descubrir",
		"General information about different thyroid conditions.": "Información general sobre diferentes afecciones de la tiroides.",
		"Calculate initial and maintenance dosages for your patients.": "Calcular las doses iniciales y de mantenimiento para sus pacientes.",
		"Calculate pack sizes": "Calcular quantidad de cajas",
		"Overview of the symptoms.": "Resumen de los síntomas.",
		"A document to track your patients' thyroid health.": "Un documento para realizar un seguimiento de la salud de la tiroides de sus pacientes.",
		"Find the pack better suited for your dosage.": "Encontre la caja más adecuado para su dosificación.",
		"Refer to the SPC.": "Consulte el SPC.",
		"Calculate recommended initial and maintenance dosages": "Cálculo para dosis inicial y control de tratamiento",
		"Levothyroxin Dosage Calculator": "Calculadora de dosis de Eutirox<sup>®</sup>",
		"Hypothyroidism": "Terapia sustitutiva",
		"Congenital or Replacement Therapy": "de la hormona tiroidea en casos de hipotiroidismo",
		"Demographic": "Demográfico",
		"Age group": "Grupo de edad",
		"year": "año",
		"years": "años",
		"Gender": "Género",
		"Male": "Hombre",
		"Female": "Mujer",
		"Condition": "Condición",
		"Which situation is best suited for your patient?": "¿Qué situación es la más adecuada para su paciente?",
		"Without associated diseases": "Sin enfermedades asociadas",
		"Pregnancy and breastfeeding": "Embarazo y lactancia",
		"The elderly or people with heart disease": "Anciano o personas com enfermedades cardíacas",
		"What are the TSH levels, weight and height of your patient?": "¿Cuáles son los niveles de TSH, el peso y la altura de su paciente?",
		"TSH Levels": "Niveles de TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Inserte los niveles de TSH, el peso y la altura del paciente",
		"Review your choices": "Revise sus elecciones",
		"The recommended doses of levothyroxine are:": "Las dosis recomendadas de Eutirox<sup>®</sup> son:",
		"Initial dose": "Dosis inicial",
		"Maintenance dose": "Dosis de mantenimiento",
		"Dose Calculation (TSH)": "Cálculo de dosis (TSH)",
		"BMI": "IMC",
		"Body Surface Area": "Área superficial del cuerpo",
		"Click button to continue": "Haga clic en el botón para continuar",
		"Select an option to continue": "Seleccione una opción para continuar",
		"Review Choices": "Revisar opciones",
		"Close": "Cerrar",
		"Intro": "Introducción",
		"Analysis": "Análisis",
		"Review": "Revisión",
		"Back to previous question": "Volver a la pregunta anterior",
		"Calculate Dosages": "Calcular las dosis",
		"Confirm": "Confirmar",
		"Year": "Año",
		"Years": "Años",
		"Result": "Resultado",
		"Results": "Resultados",
		"What is the intended prescription dosage?": "¿Cuál es la dosis de prescripción prevista?",
		"mcg/day": "mcg/día",
		"Insert the patient's daily dosage": "Insertar la dosis diaria del paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "La caja recomendada para una dosis diaria de %num% durante %days% días es:",
		"Pack": "Caja",
		"Packs": "Cajas",
		"pc-boxes": "%num% (caja|cajas) de %quant% comprimidos",
		"Dosage": "Dosis",
		"Day": "Día",
		"day": "día",
		"Days": "Días",
		"References": "Referencias",
		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "La levotiroxina es un medicamento de margen terapéutico estrecho. Por ello, el clínico prescriptor debe marcar en la receta la excepción legal correspondiente a este grupo de medicamentos para evitar el cambio de marcas en la farmacia:",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "«Excepción a) del n.º 3 del art. 6 - Margen o índice terapéutico estrecho».",
		"A mere change of brand can alter patient hormone levels by itself.": "El cambio de marcas por sí mismo puede alterar los niveles hormonales de los pacientes.",
		"Maximum 299 days": "Máximo 299 días",
		"pc-intro-txt": "<p><b>Esta herramienta calcula la dosis para Terapia sustitutiva de la hormona tiroidea en casos de hipotiroidismo, adicionalmente para</b>:</p> <p>Eutirox<sup>®</sup> 25-200 microgramos:</p> <ul><li>Tratamiento del bocio eutiroideo benigno</li> <li>Profilaxis del bocio recurrente después de la estrumectomía en pacientes con eutiroidismo, dependiendo del estado hormonal post-quirúrgico</li> <li>Terapia de supresión en casos de carcinoma tiroideo Eutirox<sup>®</sup> 25 a 100 mcg:</li> <li>Tratamiento concomitante con el tratamiento antitiroideo para los casos de hipertiroidismo.</li> </ul>",
		"Treatment control": "Control del tratamiento",
	},

	"es_MX": {
		"Diagnosis": "Diagnóstico",
		"Prescription": "Prescripción",
		"Over and Under-Dosage": "Sobredosificación y subdosificación",
		"Thyroid Journal": "Diario de la tiroides",
		"Pack Calculator": "Calculadora de cajas",
		"Technical Data": "Datos técnicos",
		"Discover": "Descubre",
		"General information about different thyroid conditions.": "Información general sobre las distintas patologías tiroideas.",
		"Calculate initial and maintenance dosages for your patients.": "Calcular la dosis inicial y la dosis máxima sugerida para sus pacientes.",
		"Calculate pack sizes": "Calcular cantidad de cajas",
		"Overview of the symptoms.": "Resumen de síntomas.",
		"A document to track your patients' thyroid health.": "Un documento para controlar la salud de la tiroides de sus pacientes.",
		"Find the pack better suited for your dosage.": "Encuentre la presentación más adecuada para la dosis calculada.",
		"Refer to the SPC.": "Ver el folleto médico del paquete de medicamentos",
		"Calculate recommended initial and maintenance dosages": "Calcular las dosis iniciales y de control recomendadas",
		"Levothyroxin Dosage Calculator": "Calculadora de dosis de levotiroxina",
		"Hypothyroidism": "Hipotiroidismo",
		"Congenital or Replacement Therapy": "indicado en la terapia de remplazo en el hipotiroidismo congénito o adquirido, de cualquier etiología",
		"Demographic": "Demográfico",
		"Age group": "Grupo de edad",
		"year": "año",
		"years": "años",
		"Gender": "Género",
		"Male": "Hombre",
		"Female": "Mujer",
		"Condition": "Condición",
		"Which situation is best suited for your patient?": "¿Qué situación es la más adecuada para su paciente?",
		"Without associated diseases": "Sin enfermedades asociadas",
		"Pregnancy and breastfeeding": "Embarazo y en periodo de lactancia",
		"The elderly or people with heart disease": "Anciano o personas com enfermedades cardíacas",
		"What are the TSH levels, weight and height of your patient?": "¿Cuál es el peso y la altura de su paciente?",
		"TSH Levels": "Niveles de TSH",
		"Weight": "Peso",
		"Height": "Altura",
		"Insert the patient's TSH Levels, weight and height": "Registre el peso y la altura del paciente",
		"Review your choices": "Revise sus elecciones",
		"The recommended doses of levothyroxine are:": "La dosis inicial sugerida de Eutirox<sup>®</sup> es:",
		"Initial dose": "Dosis inicial",
		"Maintenance dose": "Dosis máxima estimada",
		"Dose Calculation (TSH)": "Cálculo de dosis (TSH)",
		"BMI": "IMC",
		"Body Surface Area": "Área superficial del cuerpo",
		"Click button to continue": "Haga clic en el botón para continuar",
		"Select an option to continue": "Seleccione una opción para continuar",
		"Review Choices": "Revisar opciones",
		"Close": "Cerrar",
		"Intro": "Introducción",
		"Analysis": "Análisis",
		"Review": "Revisión",
		"Back to previous question": "Volver a la pregunta anterior",
		"Calculate Dosages": "Calcular las dosis",
		"Confirm": "Confirmar",
		"Year": "Año",
		"Years": "Años",
		"Result": "Resultado",
		"Results": "Resultados",
		"What is the intended prescription dosage?": "¿Cuál es la dosis de prescripción prevista?",
		"mcg/day": "mcg/día",
		"Insert the patient's daily dosage": "Insertar la dosis diaria del paciente",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "La caja recomendada para una dosis diaria de %num% durante %days% días es:",
		"Pack": "Caja",
		"Packs": "Cajas",
		"pc-boxes": "%num% (caja|cajas) de %quant% comprimidos",
		"Dosage": "Dosis",
		"Day": "Día",
		"day": "día",
		"Days": "Días",
		"References": "Referencias",
		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "&nbsp;",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "&nbsp;",
		"A mere change of brand can alter patient hormone levels by itself.": "&nbsp;",
		"Maximum 299 days": "Máximo 299 días",
		"pc-intro-txt": "<p>Esta herramienta calcula la dosis de Eutirox<sup>®</sup> para Hipotiroidismo indicado en la terapia de remplazo en el hipotiroidismo congénito o adquirido, de cualquier etiología.</p>"
		,
		"Treatment control": "Control del tratamiento",
	},

	"de_AT": {
	    "Diagnosis": "Diagnose",
	    "Prescription": "Verschreibung",
	    "Over and Under-Dosage": "Über- und Unterdosierung",
	    "Thyroid Journal": "Schilddrüsen-Tagebuch",
	    "Pack Calculator": "Packungs&shy;kalkulator",
	    "Technical Data": "Technische Daten",
	    "Discover": "Entdecken Sie",
	    "General information about different thyroid conditions.": "Allgemeine Information über verschiedene Schilddrüsenerkrankungen.",
	    "Calculate initial and maintenance dosages for your patients.": "Berechnen Sie die Anfangs- und Erhaltungsdosen für Ihre PatientInnen.",
	    "Calculate pack sizes": "Packungsgrößen berechnen",
	    "Overview of the symptoms.": "Überblick über die Symptome.",
	    "A document to track your patients' thyroid health.": "Ein Dokument zum Monitoring der Schilddrüsengesundheit Ihrer PatientInnen.",
	    "Find the pack better suited for your dosage.": "Finden Sie die Packung, die für Ihre Dosierung am besten geeignet ist.",
	    "Refer to the SPC.": "Siehe dazu die Fachinformation.",
	    "Calculate recommended initial and maintenance dosages": "Berechnung der empfohlenen Anfangs- und Erhaltungsdosen",
	    "Levothyroxin Dosage Calculator": "Levothyroxin-Dosierungs-Rechner",
	    "Intro text (need to be produced)": "Einführungstext (muss erstellt werden)",
	    "Hypothyroidism": "Hypothyreose",
	    "Congenital or Replacement Therapy": "Angeboren oder Subsititutionstherapie",
	    "Demographic": "Demografische Daten",
	    "Age group": "Altersgruppe",
	    "year": "Jahr",
	    "years": "Jahre",
	    "Gender": "Geschlecht",
	    "Male": "Männlich",
	    "Female": "Weiblich",
	    "Condition": "Gesundheitszustand",
	    "Which situation is best suited for your patient?": "Was trifft auf Ihren Patienten/Ihre Patientin am besten zu?",
	    "Without associated diseases": "Ohne Begleiterkrankungen",
	    "Pregnancy and breastfeeding": "Schwangerschaft und Stillen",
	    "The elderly or people with heart disease": "Ältere Menschen oder Menschen mit Herzkrankheiten",
	    "What are the TSH levels, weight and height of your patient?": "Welches Gewicht und welche Körpergröße hat Ihr Patient/Ihre Patientin?",
	    "TSH Levels": "TSH-Werte",
	    "Weight": "Körpergewicht",
	    "Height": "Körpergröße",
	    "Insert the patient's TSH Levels, weight and height": "Geben Sie das Gewicht und die Körpergröße des Patienten ein.",
	    "Review your choices": "Überprüfen Sie Ihre Auswahl",
	    "The recommended doses of levothyroxine are:": "Die empfohlenen Dosen von Levothyroxin sind:",
	    "Initial dose": "Anfangsdosis",
	    "Maintenance dose": "Erhaltungsdosis",
	    "BMI": "BMI",
	    "Body Surface Area": "Körperoberfläche",
	    "Click button to continue": "Klicken Sie auf die Schaltfläche, um fortzufahren",
	    "Select an option to continue": "Wählen Sie eine Option, um fortzufahren",
	    "Review Choices": "Auswahl überprüfen",
	    "Close": "Schließen",
	    "Intro": "Einleitung",
	    "Analysis": "Analyse",
	    "Review": "Überprüfung",
	    "Back to previous question": "Zurück zur vorherigen Frage",
	    "Calculate Dosages": "Dosierungen berechnen",
	    "Confirm": "Bestätigen",
	    "Year": "Jahr",
	    "Years": "Jahre",
	    "Result": "Ergebnis",
	    "Results": "Ergebnisse",
	    "What is the intended prescription dosage?": "Wie hoch ist die vorgesehene verschriebene Dosis?",
	    "mcg/day": "mcg/Tag",
	    "Insert the patient's daily dosage": "Geben Sie die Tagesdosis des Patienten ein",
	    "The recommended pack for a %num% mcg daily dosage for %days% days is:": "Die empfohlene Packung für eine Tagesdosis von %num% mcg für %days% Tage ist:",
	    "Pack": "Packung",
	    "Packs": "Packungen",
	    "Dosage": "Dosierung",
	    "Day": "Tag",
	    "day": "Tag",
	    "Days": "Tage",
	    "References": "Referenzen",
	    "Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "Levothyroxin ist ein Arzneimittel mit geringer therapeutischer Breite.",
	    "“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "&nbsp;",
	    "A mere change of brand can alter patient hormone levels by itself.": "Allein der Wechsel auf ein anderes Produkt kann bereits den Hormonspiegel von PatientInnen verändern.",
	    "Maximum 299 days": "Maximal 299 Tage",
	    "pc-boxes": "%num% (Packung|Packungen) mit %quant% Tabletten",
	    "pc-intro-txt": "<p>Dieses Tool berechnet Dosierungen für die Substitutionstherapie bei Hypothyreose (zum Ersatz natürlicher Schilddrüsenhormone, wenn die Schilddrüse nicht genügend produziert) und bei anderen Indikationen wie z. B.: </p><ul><li>Behandlung der gutartigen euthyreoten Struma bei PatientInnen mit normaler Schilddrüsenfunktion,</li><li>Rückfallprophylaxe nach chirurgischer Behandlung der euthyreoten Struma, abhängig vom postoperativen Hormonstatus,</li><li>Suppressionstherapie bei Schilddrüsenkrebs (zur Unterdrückung des Tumorwachstums bei PatientInnen mit Schilddrüsenkrebs). </li></ul>"
	},

	"pl_PL": {

		//Menu 
		"Diagnosis": "Rozpoznanie",
		"Prescription": "Przepisywanie leku",
		"Over and Under-Dosage": "Wpływ zbyt dużej lub zbyt małej dawki",
		"Thyroid Journal": "Dzienniczek chorób tarczycy",
		"Pack Calculator": "Dostosuj opakowanie Euthyrox<sup>®</sup> N",
		// "Pack Calculator": "Wybierz optymalne opakowanie Euthyrox® N",
		"Technical Data": "Charakterystyka Produktu Leczniczego Euthyrox<sup>&reg;</sup> N",
		"Discover": "Odkryj",
		//menu descriptions
		"General information about different thyroid conditions.": "Ogólne informacje dotyczące różnych schorzeń tarczycy.",
		"Calculate initial and maintenance dosages for your patients.": "Obliczanie sugerowanej dawki początkowej i docelowej",
		"Overview of the symptoms.": "Przegląd objawów podmiotowych",
		"A document to track your patients' thyroid health.": "Dokument w celu obserwacji stanu tarczycy u Twoich pacjentów.",
		"Find the pack better suited for your dosage.": "Znajdź opakowanie lepiej dostosowane do danego dawkowania.",
		"Refer to the SPC.": "VSzczegóły można znaleźć w ChPL.",

		//i menu
		"References": "Piśmiennictwo",

		// Prescription
		"Prescription": "Dobór dawki Euthyrox<sup>®</sup> N",
		"Calculate recommended initial and maintenance dosages": "Obliczanie sugerowanej dawki początkowej i szacowanej dawki maksymalnej",
		"Calculate pack sizes": "Obliczenie wielkości opakowań",
		"Levothyroxin Dosage Calculator": "Dobór dawki Euthyrox<sup>®</sup> N",
		"Intro text (need to be produced)": "Calcule a dose inicial e de manutenção recomendadas para o seu paciente.",
		"Hypothyroidism": "Niedoczynność tarczycy",
		"Congenital or Replacement Therapy": "&nbsp;",
		"Demographic": "Dane pacjenta",
		"Age group": "Grupa wiekowa",

		"year": "rok",
		"years": "lat",
		"Gender": "Płeć",
		"Male": "M",
		"Female": "K",
		"Condition": "Schorzenie",
		"Which situation is best suited for your patient?": "Która sytuacja najlepiej opisuje Twojego pacjenta?",
		"Without associated diseases": "Bez chorób współistniejących",
		"Pregnancy and breastfeeding": "Ciąża i karmienie piersią",
		"The elderly or people with heart disease": "Osoba w podeszłym wieku lub z chorobą serca",
		"What are the TSH levels, weight and height of your patient?": "Jaka jest masa ciała i wzrost pacjenta?",
		"TSH Levels": "Stężenie TSH",
		"Weight": "Masa ciała",
		"Height": "Wzrost",
		"Feet":"Stopy",
		"feet":"stopy",
		"Inches":"Cale", 
		"Insert the patient's TSH Levels, weight and height": "Podaj masę ciała i wzrost pacjenta",
		"Review your choices": "Zweryfikuj swoje wybory",
		"The recommended doses of levothyroxine are:": "Sugerowana dawka początkowa leku Euthyrox<sup>®</sup> N wynosi:",
		"Initial dose": "Dawka początkowa",
		"Maintenance dose": "Dawka podtrzymująca",
		"BMI": "BMI",
		"Body Surface Area": "Pole powierzchni ciała",
		"Click button to continue": "Aby kontynuować, kliknij przycisk",
		"Select an option to continue": "Aby kontynuować, wybierz opcję",
		"Review Choices": "Przegląd opcji wyboru",
		"Close": "Zamknij",
		"Intro": "Wprowadzenie",
		"Demographic": "Dane pacjenta",
		"Condition": "Stan Zdrowia",
		"Analysis": "BMI",
		"Review": "Werifikacja",
		"Calculate Dosages": "Obliczenie dawki",
		"Treatment control": "Kontrola leczenia",

		"Confirm": "Potwierdź",
		"Back to previous question": "Powrót do poprzedniego pytania",
		"Result": "Wynik",
		"Results": "Wyniki",

		//pack calculator
		"What is the intended prescription dosage?": "Jakie jest zalecane dawkowanie?",
		"mcg/day": "μg/dobę",
		"Insert the patient's daily dosage": "Wprowadź dawkę dobową dla pacjenta",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "Zalecane opakowanie na dzienną dawkę %num% μg przez %days% dni to:",
		"Pack": "Opakowanie",
		"Packs": "Opakowania",
		"Dosage": "Dawka",
		"Day": "Dzień",
		"day": "dzień",
		"Days": "Dni",
		"Maximum 299 days": "Maksymalnie 299 dni",
		"pc-boxes": "%num% (opakowanie|opakowania) po %quant% tabletek",

		//Specific sentences for prescription
		"pc-intro-txt": "<p>To narzędzie oblicza dawki lewotyroksyny w terapii substytucyjnej niedoczynności tarczycy i innych wskazań, takich jak np.:</p><ul><li>Leczenie łagodnego wola obojętnego u pacjentów z prawidłową czynnością tarczycy;</li><li>Profilaktyka nawrotów po operacyjnym leczeniu wola obojętnego w zależności od pooperacyjnego statusu hormonalnego;</li><li>Supresyjna terapia raka tarczycy (stosowana w celu zahamowania wzrostu guza u pacjentów z rakiem tarczycy).</li></ul>",

		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "&nbsp;",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "&nbsp;",
		"A mere change of brand can alter patient hormone levels by itself.": "Zamiana stosowanego preparatu lewotyroksyny na inny powinna odbyć się pod kontrolą TSH, ponieważ może powodować zmianę stężenia hormonów tarczycy u pacjenta.",
	},

	// English Saudi Arabia - only differing strings
	"en_SA": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		// "Levothyroxin Dosage Calculator": "Eutirox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goitre in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goitre, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Levothyroxin is:"
	},

	// English Indonesia - only differing strings
	"en_ID": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (blister|blisters) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		// "Levothyroxin Dosage Calculator": "Eutirox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goitre in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goitre, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Levothyroxin is:"
	},

	// Philipines (since default is in English, 
	// only string differing from the original are included)
	"en_PH": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Technical Data": "Product Information",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		"Levothyroxin Dosage Calculator": "Euthyrox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goiter in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goiter, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Euthyrox<sup>®</sup> is:"
	},

	// Philipines (since default is in English, 
	// only string differing from the original are included)
	"en_ZA": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		"Levothyroxin Dosage Calculator": "Euthyrox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>The treatment of hypothyroidism.</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Euthyrox<sup>®</sup> is:"
	},

	// Nigeria (since default is in English, 
	// only string differing from the original are included)
	"en_NG": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		"Levothyroxin Dosage Calculator": "Euthyrox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goitre in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goitre, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Euthyrox<sup>®</sup> is:"
	},

	"fr_MA": {

		//Menu 
		"Home": "Accueil",
		"Diagnosis": "Diagnostic",
		"Prescription": "Prescription",
		"Over and Under-Dosage": "Sur ou sous-dosages",
		"Thyroid Journal": "Journal de la thyroïde",
		"Pack Calculator": "Calculateur du nombre de boites",
		"Technical Data": "Données techniques",
		"Discover": "Découvrir",
		//menu descriptions
		"General information about different thyroid conditions.": "Information générale sur les différentes pathologies thyroïdiennes.",
		"Calculate initial and maintenance dosages for your patients.": "Calculez les doses initiales et d'entretien pour vos patients.",
		"Overview of the symptoms.": "Aperçu des symptômes.",
		"A document to track your patients' thyroid health.": "Un document pour suivre la santé thyroïdienne de vos patients.",
		"Find the pack better suited for your dosage.": "Trouvez la boite de médicaments la plus adaptée à votre dosage.",
		"Refer to the SPC.": "Se référer au Résumé des Caractéristique Produit (RCP)",

		//i menu
		"References": "Références",

		// Prescription
		"Prescription": "Prescription",
		"Calculate recommended initial and maintenance dosages": "Calculez les doses initiales et d'entretien pour vos patients.",
		"Calculate pack sizes": "Calculez la taille des boites",
		"Levothyroxin Dosage Calculator": "Calculateur de doses pour l’Eutirox<sup>®</sup>",
		// "Intro text (need to be produced)": "Calcule a dose inicial e de manutenção recomendadas para o seu paciente.",
		"Hypothyroidism": "Hypothyroïdie",
		"Congenital or Replacement Therapy": "Thérapie congénitale ou de remplacement",
		"Demographic": "Démographie",
		"Age group": "Groupe d’âge",

		"year": "an",
		"years": "ans",
		"Gender": "Sexe",
		"Male": "Hommes",
		"Female": "Femmes",
		"Condition": "Pathologie",
		"Which situation is best suited for your patient?": "Quelle est la situation la plus adaptée à votre patient ?",
		"Without associated diseases": "Sans maladies associées",
		"Pregnancy and breastfeeding": "Grossesse et allaitement",
		"The elderly or people with heart disease": "Personnes âgées avec maladies cardiaques",
		"What are the TSH levels, weight and height of your patient?": "Quels sont la taille et le poids de votre patient?",
		"TSH Levels": "Taux de TSH",
		"Weight": "Poids",
		"Height": "Tailles",
		"Insert the patient's TSH Levels, weight and height": "Insérez le poids et la taille du patient",
		"Review your choices": "Modifiez vos choix",
		"The recommended doses of levothyroxine are:": "les dosage recommandées de lévothyroxine sont les suivantes:",
		"Initial dose": "Dose initiale suggérée",
		"Maintenance dose": "Dose d'entretien",
		"BMI": "IMC",
		"Body Surface Area": "Surface corporelle",
		"Click button to continue": "Cliquez pour continuer",
		"Select an option to continue": "Choisir une option pour continuer",
		"Review Choices": "Modifiez vos choix",
		"Close": "Fermer",
		"Intro": "Intro",
		"Demographic": "Démographie",
		"Condition": "Pathologie",
		"Analysis": "Analyse",
		"Review": "Examen",
		"Calculate Dosages": "Calculez les dosages",
		"Treatment control": "Surveillance du traitement",

		"Confirm": "Confirmez",
		"Back to previous question": "Retour à la question précédente",
		"Result": "Résultat",
		"Results": "Résultats",

		//pack calculator
		"What is the intended prescription dosage?": "Quel est le dosage prévu sur l'ordonnance?",
		"mcg/day": "mcg/jour",
		"Insert the patient's daily dosage": "Insérez le dosage journalier du patient",
		"The recommended pack for a %num% mcg daily dosage for %days% days is:": "Le nombre de boîtes recommandé pour un dosage journalier de %num% mcg pendant %days% est:",
		"Pack": "Boite",
		"Packs": "Boîtes",
		"Dosage": "Dosage",
		"Day": "Jour",
		"day": "jour",
		"Days": "Jours",
		"Maximum 299 days": "Maximum 299 jours",
		"pc-boxes": "%num% (boite|boîtes) de %quant% pilules",

		//Specific sentences for prescription
		"pc-intro-txt": "<p>Cet outil calcule les dosages pour la thérapie de substitution dans l'hypothyroïdie (pour remplacer les hormones thyroïdiennes naturelles, lorsque les hormones thyroïdiennes produisent suffisamment), et dans d'autres indications telles que : <ul> <li>Traitement du goitre euthyroïdien bénin chez les patients dont la fonction thyroïdienne est normale;</li> <li>Prophylaxie contre la rechute après une intervention chirurgicale pour un goitre euthyroïdien, en fonction du statut hormonal postopératoire;</li> <li>Thérapie de suppression en cas de cancer de la thyroïde (pour supprimer la croissance tumorale chez les patients atteints de cancer de la thyroïde).</li></p>",

		"Levothyroxine is a medicinal product with a narrow therapeutic margin. Therefore, prescribers should state in the prescription the legal exception corresponding to this group of drugs to prevent a change of brand at the pharmacy:": "La lévothyroxine est un médicament à marge thérapeutique étroite. Par conséquent, les prescripteurs doivent indiquer sur l'ordonnance l'exception légale correspondant à ce groupe de médicaments afin d'éviter un changement de marque à la pharmacie :",
		"“Exception a) in Article 6(3) - Narrow therapeutic index or margin.”": "“Exception a) à l'article 6, (3) - Index thérapeutique étroit ou marge thérapeutique étroite.”",
		"A mere change of brand can alter patient hormone levels by itself.": "Un simple changement de marque peut modifier les niveaux d'hormones du patient.",
	},

	// Kenya (since default is in English, 
	// only string differing from the original are included)
	"en_KE": {
		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		"Levothyroxin Dosage Calculator": "Euthyrox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goitre in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goitre, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Euthyrox<sup>®</sup> is:"
	},

	// Egypt (since default is in English, 
	// only string differing from the original are included)
	"en_EG": {
		"Initial dose": "Initial Dose for Titration",
		"Maintenance dose": "Recomended Maintenance Dose",
		"Dose Calculation (TSH)": "Recomended Dose",

		"Hypothyroidism": "Substitution therapy in hypothyroidism",
		"Congenital or Replacement Therapy": "(to replace natural thyroid hormones, when your thyroid doesn't produce enough)",
		"Calculate recommended initial and maintenance dosages": "Calculation for suggested starting dose and estimated maximum dose",
		"pc-boxes": "%num% (box|boxes) of %quant% tablets",
		"What are the TSH levels, weight and height of your patient?": "What is the weight and height of your patient?",
		"Levothyroxin Dosage Calculator": "Euthyrox<sup>&reg;</sup> Dosage Calculator",
		"pc-intro-txt": "<p>This tool calculates dosages for substitution therapy in hypothyroidism (to replace natural thyroid hormones, when your thyroid doesn't produce enough), and in other indications such as:</p><ul><li>Treatment of benign euthyroid goitre in patients with normal thyroid function,</li><li>Prophylaxis of relapse after surgery for euthyroid goitre, depending on the postoperative hormone status,</li><li>Suppression therapy in thyroid cancer (to suppress tumor growth in patients with thyroid cancer).</li></ul>",
		"Insert the patient's TSH Levels, weight and height": "Insert patient's weight and height",
		"The recommended doses of levothyroxine are:": "The Estimated maximum dose of Euthyrox<sup>®</sup> is:",
		"Without associated diseases": "Without associated conditions",	
	},

};

const refsTranslation = {

	"default": {
		"prescription": ['No references']
	},

	"pt_BR": {
		"prescription": [
			"Bula do produto Euthyrox ® Levotiroxina sódica, medicamento similar equivalente ao medicamento de referência, expediente ANVISA 0511812230 data de publicação 19/05/2023, M.S. 1.0089.0202. Apresentação de 137 mcg, expediente ANVISA 0449417239 data de publicação 04/05/2023, M.S. 1.0089.0359.",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L.,et al. Consenso em Tireoide. Diretrizes clínicas práticas para o manejo do hipotiroidismo. Arquivo Bras Endrocrinol Metab. 2013; 57/4. Pag. 265-299",
			"Sgarbi JA, Ward LS. A practical contemporary approach to decision-making on subclinical hypothyroidism. Arch Endocrinol Metab. 2021 Nov 1;65(1):32-39. doi: 10.20945/2359-3997000000317. Epub 2020 Dec 15. PMID: 33320453",
			"Alexander EK, Pearce EN, Brent GA, Brown RS, Chen H, Dosiou C, Grobman WA, Laurberg P, Lazarus JH, Mandel SJ, Peeters RP, Sullivan S. 2017 Guidelines of the American Thyroid Association for the Diagnosis and Management of Thyroid Disease During Pregnancy and the Postpartum. Thyroid. 2017 Mar;27(3):315-389. doi: 10.1089/thy.2016.0457. Erratum in: Thyroid. 2017 Sep;27(9):1212. PMID: 28056690",
			"Solha STG, Mattar R, Teixeira PFDS, <i>et al</i>. Screening, diagnosis and management of hypothyroidism in pregnancy. Rev Bras Ginecol Obstet. 2022;44(10):999-1010. doi:10.1055/s-0042-1758490.",
			"Calculadora de dosagens T-Lab 3: v2.3.0 - 2024-07-01"
		]
	},

	"es_CL": {
		"prescription": [
			"Folleto al profesional CCDS v8.0, Depto. Asuntos Regulatorios, Chile, Abril 2021.",
			"Ministerio de Salud, Chile. Guía Clínica AUGE Hipotiroidismo en personas de 15 años y más.  Serie Guias Clínicas MINSAL, 2013",
			"Jonklaas, J, Bianco, A, Bauer, A.,et al. Guidelines for the treatment of Hypothyroidism.  Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Calculadora de dosagens T-Lab 3: v2.3.0 - 2024-10-09"
		]
	},

	"pt_PT": {
		"prescription": [
			"RCM do produto Eutirox<sup>®</sup> Levotiroxina sódica, medicamento similar equivalente ao medicamento de referência, aprovada pela ANVISA em 01/03/2021.",
			"Freitas, C., <i>et al</i>. Documento de Consenso da Sociedade Portuguesa de Endocrinologia, Diabetes e Metabolismo (SPEDM) e do Grupo de Estudos da Tiroide (GET) sobre Diagnóstico, Tratamento e Seguimento do Hipotiroidismo Primário no Adulto Rev Port Endocrinol Diabetes Metab. 2019;14(2)"
		]
	},

	"es_CT": {
		"prescription": [
			"Información del producto Eutirox<sup>®</sup>, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism.  Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas et al Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014  DOI: 10.1089/thy.2014.0028"
		]
	},

	"es_GT": {
		"prescription": [
			"Información del producto Eutirox<sup>®</sup>, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism.  Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas et al Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014  DOI: 10.1089/thy.2014.0028"
		]
	},

	"en_CT": {
		"prescription": [
			"Product information Eutirox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"en_GT": {
		"prescription": [
			"Product information Eutirox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"es_CO": {
		"prescription": [
			"Información para prescribir, Levotiroxina CCDS V6.0 2017May12 LATAM",
			"Jonklaas, J, Bianco, A, Bauer, A.,et al. Guidelines for the treatment of Hypothyroidism.  Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Craven M, Frank GR. Does initial dosing of levothyroxine in infants with congenital hypothyroidism lead to frequent dose adjustments secondary to iatrogenic hyperthyroidism on follow-up? J Pediatr Endocrinol Metab. 2018 Jun 27;31(6):597-600. doi: 10.1515/jpem-2017-0513. PMID: 29715192.",
			"Levothyroxine Sodium Pediatric Monographs, ScriptSave, WellRx. General Administration Information in https://www.wellrx.com/LEVOTHYROXINE%20SODIUM/pediactric-monographs/",
			"Libro Aspectos Claves de Tiroides. CIB fondo editorial. Segunda Edición ISBN:978-958-5548-82-4. Capítulo 7 Tratamiento del Hipotiroidismo. Carlos Alfonso Builes Barrera"
		]
	},

	"es_EC": {
		"prescription": [
			"Información para prescribir, Eutirox® CCDS V6.0 2017May12 LATAM",
			"Jonklaas, J, Bianco, A, Bauer, A.,et al. Guidelines for the treatment of Hypothyroidism.  Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Craven M, Frank GR. Does initial dosing of levothyroxine in infants with congenital hypothyroidism lead to frequent dose adjustments secondary to iatrogenic hyperthyroidism on follow-up? J Pediatr Endocrinol Metab. 2018 Jun 27;31(6):597-600. doi: 10.1515/jpem-2017-0513. PMID: 29715192.",
			"Levothyroxine Sodium Pediatric Monographs, ScriptSave, WellRx. General Administration Information in https://www.wellrx.com/LEVOTHYROXINE%20SODIUM/pediactric-monographs/",
			"Libro Aspectos Claves de Tiroides. CIB fondo editorial. Segunda Edición ISBN:978-958-5548-82-4. Capítulo 7 Tratamiento del Hipotiroidismo. Carlos Alfonso Builes Barrera"
		]
	},

	"es_PE": {
		"prescription": [
			"Información del producto Eutirox® Tabletas, CCDS v 7 6-5-2021, last review Abril 2020",
			"Jonklaas, J, Bianco, A, Bauer, A.,et al. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Levy EG, Ridgway EC, Wartofsky L. Algorithms for diagnosis and management of thyroid disorders. http://www.thyroidtoday.com/ExpertOpinions/ThyroidDiseaseAlgorithms.pdf. Accessed February 1, 2012",
			"Asociación Americana de Tiroides (ATA). Arq. Bras Endocrinol Metab. 2013:57 (3): 166-183. Thyroid. 2017: 27 (3) : 315-388"
		]
	},

	"es_MX": {
		"prescription": [
			"Información para prescribir, MX- IPP-W - Eutirox all strengths Technical variation (NF) - 2022 April 06 SP – MX",
			"Jonklaas, J, Bianco, A, Bauer, A.,et al. Guidelines for the treatment of Hypothyroidism.  Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Guía de práctica clínica: Diagnóstico y tratamiento de Hipotiroidismo primario y Subclínico en el adulto. Catálogo Maestro de guías de práctica clínica: IMSS-265-10, Actualización 2016.",
			"Prevención, Diagnóstico y Tratamiento del Hipotiroidismo Congénito Neonatal en el Primer Nivel de Atención. México: Secretaria de Salud; 2008.",
			"Mora Sitja M, Sanz Fernández M, Carrascón González-Pinto M, Rodríguez Sánchez A. Review of the guidelines on congenital hypothyroidism. Latest developments in the management of congenital hypothyroidism. Rev Esp Endocrinol Pediatr. 2022; 13 (Suppl 1).",
			"Castilla Peón MF. Hipotiroidismo congénito [Congenital hypothyroidism]. Bol Med Hosp Infant Mex. 2015 Mar-Apr;72(2):140-148.",
			"Calzada-León R, Ruìz-Reyes, ML, Rivera-Hernández A, Bahena-García AL. Cáncer diferenciado de tiroides en niños. Rev Mex Endocrinol Metab Nutr 2020; 7:37-42.",
			"Levy EG, Ridgway EC, Wartofsky L. Algorithms for diagnosis and management of thyroid disorders. http://www.thyroidtoday.com/ExpertOpinions/ThyroidDiseaseAlgorithms.pdf. Accessed February 1, 2012 (REF-60714)",
			"Asociación Americana de Tiroides (ATA). Arq. Bras Endocrinol Metab. 2013:57 (3): 166-183. Thyroid. 2017: 27 (3) : 315-388",
			"Brenta, G., Vaisman, M., Sgarbi, J. A., Bergoglio, L., Carvalho de Andrada, N., Pineda Bravo, P., ... & Graf, H. (2013). Guías de práctica clínica para el tratamiento del hipotiroidismo. Arq Bras Endocrinol Metab, 57(4), 2265-99.",
			"Medrano OZME , de Santillana-Hernández SP, Torres-Arreola LP, et al. Guía de práctica clínica. Diagnóstico y tratamiento del hipotiroidismo primario en adultos. Rev Med Inst Mex Seguro Soc. 2012;50(1):71-80."
		]
	},

	"de_AT": {
		"prescription": [
			"Wassner AJ.; Pediatric Hypothyroidism: Diagnosis and Treatment, Pediatr Drugs 2017;19:291–303 ",
			"Jonklaas J; Guidelines for the Treatment of Hypothyroidiam, prepared by ATA, Thyroid Volume 24, Number 12 (2014)"
		]
	},

	"pl_PL": {
		"prescription": [
			"Charakterystyka Produktu Leczniczego Euthyrox<sup>®</sup> N z dnia 03.2023.",
			"Jonklaas J, Bianco AC, Bauer AJ, <i>et al</i>. Guidelines for the treatment of hypothyroidism: prepared by the american thyroid association task force on thyroid hormone replacement. Thyroid. 2014;24(12):1670-1751.			"
		]
	},

	"en_SA": {
		"prescription": [
			"Product information Euthyrox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"en_ID": {
		"prescription": [
			"Product information Euthyrox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"en_PH": {
		"prescription": [
			"Philippines Product Information Euthyrox<sup>®</sup>, Active Ingredient: Levothyroxine Sodium. Updated in 2023-11-13",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028",
			"T-Lab Dosage calculator - 2024-11-13"
		]
	},

	"en_ZA": {
		"prescription": [
			"Product information Euthyrox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"en_NG": {
		"prescription": [
			"Product information Euthyrox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"fr_MA": {
		"prescription": [
			"Product information Euthyrox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"en_KE": {
		"prescription": [
			"Product information Euthyrox®, Ingrediente Activo: Levotiroxina sódica. Version 04 del 2019-06-19",
			"Brenta G, Vaisman M, Sgarbi A. Bergoglio L., <i>et al</i>. Thyroid consensus. Clinical practice guidelines for the management of hypothyroidism. Arq Bras Endocrinol Metab. 2013;57/4. Pag. 265-299",
			"Jonklaas, J, Bianco, A, Bauer, A., <i>et al</i>. Guidelines for the treatment of Hypothyroidism. Prepared by the American Thyroid Association. Task force on Thyroid Hormone Replacement. Special article. Thyroid volume 24, number 12, 2014. ©American Thyroid Association. DOI: 10.1089/thy.2014.0028",
			"Werner et al. The Thyroid Disorder of the Thyroid Gland in Infancy, Childhood and adolescence.",
			"Cooper D., Subclinical Thyroids disease. The Johns Hopkins University School of Medicine, Lancet 2012; 379:1142-54 Published Online January 23,2012",
			"Jacqueline Jonklaas <i>et al</i> Guidelines for the Treatment of Hypothyroidism American Thyroid Association Task Force on Thyroid Hormone Replacement THYROID Volume 24, Number 12, 2014 DOI: 10.1089/thy.2014.0028"
		]
	},

	"en_EG": {
		"prescription": [
			"Lazarus J, Brown RS, Daumerie C, Hubalewska-Dydejczyk A, Negro R, Vaidya B. 2014 European thyroid association guidelines for the management of subclinical hypothyroidism in pregnancy and in children. European thyroid journal. 2014;3(2):76-94.",
			"Egyptian Drug Authority Euthyrox approved leaflet date: 22.2.2023.",
			"Jonklaas J, Bianco AC, Bauer AJ, et al. Guidelines for the treatment of hypothyroidism: prepared by the American Thyroid Association Task Force on thyroid hormone replacement. thyroid. 2014;24(12):1670-751.",
			"Garber JR, Cobin RH, Gharib H, et al. Clinical practice guidelines for hypothyroidism in adults: cosponsored by the American Association of Clinical Endocrinologists and the American Thyroid Association. Endocr Pract. 2012;(6):988-1028."
		]
	}
};

// Diagnosis - General information about different thyroid conditions.
// Prescription - Calculate initial and maintenance dosages for your patients.
// Effects of overdose and under-dosing - Overview of the symptoms.
// Thyroid Journal - A document to track your patients' thyroid health.
// Pack Calculator - Find the pack better suited for your dosage.
// Technical Data - Refer to the SPC.
// Discover

// Diagnóstico - Informação geral sobre as diversas patologias da tireoide.
// Prescrição - cálculo da dose inicial e de manutenção recomendadas para os seus doentes.
// Efeitos da super e subdosagem - Visão geral dos sintomas.
// Diário da Tireoide - Um documento para acompanhamento da saúde da tireoide dos seus doentes.
// Calculadora de Embalagens - Descubra a embalagem mais adequada para a sua dosagem.
// Dados técnicos - ver a bula do medicamento
// Descubra
